import { breadcrumb } from './breadcrumb';
import { campaign } from './campaign';
import { stats } from './stats';
import { webhook } from './webhook';
import { task } from './task';
import { operators } from './operators';
import { monitoring } from './monitoring';
import { monitoring_general } from './monitoring_general';

export const autocaller_v2 = {
  breadcrumb,
  campaign,
  stats,
  webhook,
  task,
  operators,
  monitoring,
  monitoring_general,

  products: {
    title: 'Product',
    tooltips: {
      usage:
        'It is taken into account if the item "Take into account the skills of operators" is selected in the campaign settings.'
    },
    table: {
      name: "The product's name"
    },
    remove: 'Are you sure you want to delete the product {name}?'
  },

  validator: {
    field: {
      calls_limit: {
        max_value: 'Predictive Dialer supports no more than 250 simultaneous connections.'
      },
      date_time_error: 'The date and time must be later than the current in UTC +00:00'
    }
  }
};
